/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllPalSubmissionsResponse } from './FindAllPalSubmissionsResponse';
import {
    FindAllPalSubmissionsResponseFromJSON,
    FindAllPalSubmissionsResponseFromJSONTyped,
    FindAllPalSubmissionsResponseToJSON,
} from './FindAllPalSubmissionsResponse';

/**
 * 
 * @export
 * @interface FindAllPalSubmissions200Response
 */
export interface FindAllPalSubmissions200Response {
    /**
     * 
     * @type {FindAllPalSubmissionsResponse}
     * @memberof FindAllPalSubmissions200Response
     */
    data?: FindAllPalSubmissionsResponse;
}

/**
 * Check if a given object implements the FindAllPalSubmissions200Response interface.
 */
export function instanceOfFindAllPalSubmissions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalSubmissions200ResponseFromJSON(json: any): FindAllPalSubmissions200Response {
    return FindAllPalSubmissions200ResponseFromJSONTyped(json, false);
}

export function FindAllPalSubmissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalSubmissions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllPalSubmissionsResponseFromJSON(json['data']),
    };
}

export function FindAllPalSubmissions200ResponseToJSON(value?: FindAllPalSubmissions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllPalSubmissionsResponseToJSON(value.data),
    };
}

